import { inject } from 'vue'
import mitt from 'mitt'
import Notice from './Notice.vue'

export const emitter = mitt()
export const NoticeSymbol = Symbol()

export function useNotice() {
	const Notice = inject(NoticeSymbol)
	if (!Notice) {
		throw new Error(`No notice`)
	}
	return Notice
}

export const NoticePlugin = {
	install: (app) => {
		const NoticeService = {
			show: (msg, options = {}) => {
				emitter.emit('show', {msg, options})
			},
			hide: () => {
				emitter.emit('hide')
			},
		}

		app.config.globalProperties.$notice = NoticeService
		app.component('Notice', Notice)
		if (typeof window !== 'undefined') window.$notice = NoticeService
		app.provide(NoticeSymbol, NoticeService)
	}
}
